exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"colorNeedsImprovement": "#de4c4c",
	"colorDeveloping": "#f7932d",
	"colorOnTrack": "#74d17f",
	"colorOutstanding": "#74d17f",
	"colorDefault": "#0087e6"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/build-omni-operation-ui_develop/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/UnitReportHFv4/StudentReportView/ScoreBand/hfv4BandColors.postcss
// module id = 1945
// module chunks = 0